// extracted by mini-css-extract-plugin
export var content = "HeroImage-module--content--70655";
export var heroImage = "HeroImage-module--heroImage--d6bd8";
export var imageWrapper = "HeroImage-module--imageWrapper--f16b3";